@use '../../../../tti-design-styles/src/molecules/circular-progress' as *;

:host {
   display: inline-block;
}
